import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './App.scss'
import { RecoilRoot } from 'recoil'
import { NotificationProvider } from './Context/Notification.context'
import { QuestionProvider } from './Context/QuestionContext'
import './index.css'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.ts')
    .then((registration) => {
      console.log('Service Worker registered:', registration)
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error)
    })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <NotificationProvider>
      <QuestionProvider>
        <App />
      </QuestionProvider>
    </NotificationProvider>
  </React.StrictMode>
)
